import moment from 'moment/moment';

export function formatDateTime(date, format = 'DD-MM-YYYY HH:mm') {
    if (!date) {
        return '';
    }

    return moment(date).format(format);
}
